export class RealEstateProject {
  //todo needs to be updated to match actual requirements
  Department: string;
  Funding_Type: string;

  constructor(department: string = "", fundingType: string = "") {
    this.Department = department;
    this.Funding_Type = fundingType;
  }
}

export class RealEstateBuildingDetails {
  active: string;
  address: string;
  asset_location: string;
  bu: string;
  building_id: string;
  building_name: string;
  business_segment: string;
  city: string;
  function: string;
  functional_class: string;
  funding_project: string;
  legal_entity: string;
  major_location: string;
  project_type: string;
  state: string;
  uda_status: string;
  zip_code: string;
  om_operating_units: string;
  capital_operating_units: string;
  om_account_num: string;
  capital_cwip_account_num: string;
  capital_rwip_account_num: string;
  asset_location_id: string;
  major_location_id: string;
}
[];

export class RealEstateUopEstimates {
  uop: string;
  uop_desc: string;
  install_material: string;
  install_labor: string;
  removal_labor: string;
}
[];

export class RealEstateUopOption {
  uop_comp: string;
  materiality_threshold: string;
  uop_subsys: string;
  uop_id: string;
  uop_sys: string;
  ferc: string;
  unit_of_property: string;
  materiality_description: string;
  acct_description: string;
}
[];

export class RealEstateFundingProject {
  fundingProject: string;
}
[];
export class RealEstateEstimate {
  work_task: string;
  expenditure_type: string;
  estimated_cost: string;
  detail_project_id: string;
  activity_id: string;
  operating_unit_id: string;
  process_code: string;
  responsibility_center: string;
  account_number: string;
  charge_type: string;
  project_charge_indicator: string;
}
[];

export interface ProjectEstimateFormValue {
  estimates: any[];
  chargeSummary: any;
  expenditureSummary: any;
}

export interface ProjectUopFormValue {
  uopDetails: any[];
}
